import {
  findUserTokenInStorage,
  logInWithPassword,
  login,
  logOut,
  setUserToken,
  fakeSessionLogIn,
  setFakeSession,
  getUserDataByToken,
} from "./authActions";
import { Action } from "../../models/Action";
import { GET_USER_DATA_URL, LOGIN_USER_URL } from "../../api/apiRoutes";

export const USER_TOKEN = "userToken";

const authMiddleware = (store: any) => (next: (action: Action<any>) => void) => (action: any) => {
  if (action.type === login.fulfilled.toString()) {
    sessionStorage.setItem(USER_TOKEN, JSON.stringify(action.payload));
  }

  if (action.type === logInWithPassword.toString()) {
    store.dispatch(login({ url: LOGIN_USER_URL, data: action.payload }));
  }

  if (action.type === logOut.toString()) {
    sessionStorage.removeItem(USER_TOKEN);
    store.dispatch(fakeSessionLogIn());
  }

  if (action.type === login.fulfilled.toString()) {
    store.dispatch(setUserToken(action.payload));
  }

  if (action.type === findUserTokenInStorage.toString()) {
    const userToken = sessionStorage.getItem(USER_TOKEN);
    if (userToken) {
      const parsedUserToken = JSON.parse(userToken);
      if (parsedUserToken.userName.substring(0, 5) === "GUEST") {
        store.dispatch(setFakeSession(parsedUserToken));
      } else {
        store.dispatch(setUserToken(parsedUserToken));
      }
    }
  }

  if (action.type === fakeSessionLogIn.fulfilled.toString()) {
    sessionStorage.setItem(USER_TOKEN, JSON.stringify(action.payload));
    store.dispatch(setFakeSession(action.payload));
  }

  next(action);
};

export default authMiddleware;
